<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Library List">
       
        <div class="row">
          <!-- Parent Topic Modal -->
          <div class="col-md-6 form-group">
            <b-modal
              id="modal-1"
              title="Add Parent Topic"
              size="lg"
              ref="modalone"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div>
                Topic
                <input
                  class="col-md-6 form-control"
                  @focus="parentTopicEmpty = false"
                  v-model="parentLibraryName"
                />
                <div
                  class="form-group"
                  style="color: red"
                  v-if="parentTopicEmpty"
                >
                  Topic is required
                </div>
                <div>
                  <b-button
                    @click="addParentLibrary()"
                    variant="success"
                    class="float-right ml-2"
                    >Insert</b-button
                  >
                  <b-button
                    @click="cancelButtonParentLibrary()"
                    variant="danger"
                    class="float-right"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </b-modal>
            <!-- Parent topic edit modal -->
            <b-modal
              id="modal-3"
              title="Edit Parent Topic"
              size="lg"
              ref="modalthree"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div>
                Topic
                <input
                  class="col-md-6 form-control"
                  @focus="parentTopicEmpty = false"
                  v-model="parentLibraryName"
                />
                <div
                  class="form-group"
                  style="color: red"
                  v-if="parentTopicEmpty"
                >
                  Topic is required
                </div>
                <div>
                  <b-button
                    @click="editParentTopics()"
                    variant="success"
                    class="float-right ml-2"
                    >Save Changes</b-button
                  >
                  <b-button
                    variant="danger"
                    class="float-right"
                    @click="editCancelButtonParentLibrary"
                    >Cancel</b-button
                  >
                </div>
              </div>
            </b-modal>

            <!-- Parent topic list -->
            
              <b-list-group v-if="$store.getters.userDetails.includes('CAN_ADD_LIBRARY')">
                Parent Topics
                <b-list-group-item
                  id="addParentTopicButton"
                  v-b-modal.modal-1
                  class="mb-1"
                  button
                  >+ Add Parent Topic</b-list-group-item
                ></b-list-group
              >
              <div style="max-height: 280px; overflow-y: scroll">
              <b-list-group
                v-for="(parentTopic, index) in parentTopics"
                :key="index"
                class="mb-1"
              >
                <b-list-group-item
                  >{{ parentTopic.name }}
                  <b-btn-group class="float-right">
                    <b-button v-if="$store.getters.userDetails.includes('CAN_EDIT_LIBRARY')"
                      size="sm"
                      variant="alt-primary"
                      v-b-modal.modal-3
                      @click="loadParentTopic(parentTopic.id)"
                    >
                      <i class="fa fa-fw fa-pencil-alt"></i>
                    </b-button>

                    <b-button v-if="$store.getters.userDetails.includes('CAN_DELETE_LIBRARY')"
                      size="sm"
                      variant="alt-primary"
                      @click="deleteParentTopic(parentTopic.id)"
                    >
                      <i class="fa fa-fw fa-trash"></i>
                    </b-button>

                  
                    <b-button v-if="$store.getters.userDetails.includes('CAN_ADD_LIBRARY')"
                      size="sm"
                      variant="alt-primary"
                      @click="getLibraries(parentTopic.id)"
                    >
                      <i class="fa fa-fw fa-angle-right"></i>
                    </b-button>
                  </b-btn-group>
                  <b-button  v-if="$store.getters.userDetails.includes('CAN_STATUS_LIBRARY')"
                    size="sm"
                    :variant="parentTopic.status ? 'success' : 'danger'"
                    class="float-right mr-1"
                    @click="
                      parentTopicStatus(
                        parentTopic.id,
                        index,
                        parentTopic.status
                      )
                    "
                  >
                    <i
                      :class="
                        parentTopic.status
                          ? 'fa fa-fw fa-check'
                          : 'fa fa-fw fa-times'
                      "
                    ></i>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>

          <!-- Library List-->
          <div class="col-md-6 form-group">
              <b-list-group v-if="addlibraryButton && $store.getters.userDetails.includes('CAN_ADD_LIBRARY')">
                Library
                <b-list-group-item
                  id="addLibraryButton"
                  v-b-modal.modal-2
                  class="mb-1"
                  button
                  >+ Add Library</b-list-group-item
                ></b-list-group
              >
              <div style="max-height: 280px; overflow-y: scroll">
              <b-list-group
                v-for="(library, index) in libraries"
                :key="index"
                class="mb-1"
              >
                <b-list-group-item
                  >{{ library.name
                  }}<b-btn-group class="float-right"
                    ><b-button v-if="$store.getters.userDetails.includes('CAN_EDIT_LIBRARY')"
                      size="sm"
                      variant="alt-primary"
                      @click="loadLibrary(library.id)"
                      v-b-modal.modal-4
                    >
                      <i class="fa fa-fw fa-pencil-alt"></i>
                    </b-button>

                    <b-button v-if="$store.getters.userDetails.includes('CAN_DELETE_LIBRARY')"
                      size="sm"
                      variant="alt-primary"
                      @click="deleteLibrary(library.id)"
                    >
                      <i class="fa fa-fw fa-trash"></i>
                    </b-button>
                  </b-btn-group>
                  <b-button v-if="$store.getters.userDetails.includes('CAN_STATUS_LIBRARY')"
                    size="sm"
                    :variant="library.status ? 'success' : 'danger'"
                    class="float-right mr-1"
                    @click="
                      libraryStatus(
                        library.id,
                        index,
                        library.status
                      )
                    "
                  >
                    <i
                      :class="
                        library.status
                          ? 'fa fa-fw fa-check'
                          : 'fa fa-fw fa-times'
                      "
                    ></i>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>

            <!-- Library Modal -->
            <b-modal
              id="modal-2"
              ref="modaltwo"
              title="Add Library"
              size="lg"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div class="row">
                <div class="col-md-6 form-group">
                  Name
                  <input
                    class="form-control"
                    v-model="libraryName"
                    @focus="libraryNameEmpty = false"
                  />
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryNameEmpty"
                  >
                    Library Name is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Description
                  <input
                    class="form-control"
                    v-model="libraryDescription"
                    @focus="libraryDescriptionEmpty = false"
                  />
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryDescriptionEmpty"
                  >
                    Library Description is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Image
                  <b-form-file
                    class="form-control"
                    @change="libraryimageUpload"
                  ></b-form-file>
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryImageEmpty"
                  >
                    Library Image is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Document
                  <b-form-file
                    accept="application/pdf"
                    class="form-control"
                    @change="libraryDocumentUpload"
                  ></b-form-file>
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryDocumentEmpty"
                  >
                    Library Document is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Document Access
                  <b-form-checkbox v-model="viewAccess">View</b-form-checkbox>
                  <b-form-checkbox v-model="downloadAccess"
                    >Download</b-form-checkbox
                  >
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryCheckboxEmpty"
                  >
                    Please check any one of the checkbox atleast
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  @click="addLibrary()"
                  variant="success"
                  class="float-right ml-2"
                  >Insert</b-button
                >
                <b-button
                  @click="cancelButtonLibrary()"
                  variant="danger"
                  class="float-right"
                  >Cancel</b-button
                >
              </div>
            </b-modal>

            <!-- Library edit modal -->
            <b-modal
              id="modal-4"
              ref="modalfour"
              title="Edit Library"
              size="lg"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div class="row">
                <div class="col-md-6 form-group">
                  Name
                  <input
                    class="form-control"
                    v-model="libraryName"
                    @focus="libraryNameEmpty = false"
                  />
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryNameEmpty"
                  >
                    Library Name is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Description
                  <input
                    class="form-control"
                    v-model="libraryDescription"
                    @focus="libraryDescriptionEmpty = false"
                  />
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryDescriptionEmpty"
                  >
                    Library Description is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Image
                  <b-form-file
                    class="form-control"
                    @change="libraryimageUpload"
                  ></b-form-file>
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryImageEmpty"
                  >
                    Library Image is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Document
                  <b-form-file
                    accept="application/pdf"
                    class="form-control"
                    @change="libraryDocumentUpload"
                  ></b-form-file>
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryDocumentEmpty"
                  >
                    Library Document is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Document Access
                  <b-form-checkbox v-model="viewAccess">View</b-form-checkbox>
                  <b-form-checkbox v-model="downloadAccess"
                    >Download</b-form-checkbox
                  >
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="libraryCheckboxEmpty"
                  >
                    Please check any one of the checkbox atleast
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  @click="editLibrary()"
                  variant="success"
                  class="float-right ml-2"
                  >Save changes</b-button
                >
                <b-button
                  variant="danger"
                  class="float-right"
                  @click="editLibraryCancelButton()"
                  >Cancel</b-button
                >
              </div>
            </b-modal>
          </div>
        </div>
       
       <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
        <!-- End Loader -->
        
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
       loader: false,
      editLibraryId: 0,
      editParentTopicId: 0,
      libraryCheckboxEmpty: false,
      libraryDocumentEmpty: false,
      libraryImageEmpty: false,
      libraryDescriptionEmpty: false,
      libraryNameEmpty: false,
      addlibraryButton: false,
      requiredLibraryId: 0,
      libraryName: "",
      libraryDescription: "",
      libraryImage: "",
      libraryDocument: "",
      viewAccess: "",
      downloadAccess: "",
      parentTopicEmpty: false,
      parentLibraryName: "",
      parentTopics: [],
      libraries: [],
    };
  },
  mounted() {
    this.getParentTopics();
  },
  methods: {
    async libraryStatus(id, index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/libraries/status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.libraries[index].status = status == 1 ? 0 : 1
            this.$swal(
              "Success",
              "Library status changed successfully",
              "success"
            );
            
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },
    async parentTopicStatus(id ,index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/libraries/status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.parentTopics[index].status = status == 1 ? 0 : 1
           this.$swal({text:`${response.data.message} successfully`,icon:status?'error':'success'});
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },
    editLibraryCancelButton() {
      this.$refs.modalfour.hide();
      (this.libraryName = ""),
        (this.libraryDescription = ""),
        (this.libraryImage = ""),
        (this.libraryDocument = "");
      (this.viewAccess = ""), (this.downloadAccess = "");
      (this.libraryCheckboxEmpty = false),
        (this.libraryDocumentEmpty = false),
        (this.libraryImageEmpty = false),
        (this.libraryDescriptionEmpty = false),
        (this.libraryNameEmpty = false);
    },

    async editLibrary() {
      if (this.libraryName == "") {
        this.libraryNameEmpty = true;
        return;
      }
      if (this.libraryDescription == "") {
        this.libraryDescriptionEmpty = true;
        return;
      }
      if (this.libraryImage == "") {
        this.libraryImageEmpty = true;
        return;
      }
      if (this.libraryDocument == "") {
        this.libraryDocumentEmpty = true;
        return;
      }
      if (this.viewAccess == "" && this.downloadAccess == "") {
        this.libraryCheckboxEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.libraryName);
      formdata.append("description", this.libraryDescription);
      formdata.append("image", this.libraryImage);
      formdata.append("document", this.libraryDocument);
      formdata.append("download", this.downloadAccess ? 1 : 0);
      formdata.append("view", this.viewAccess ? 1 : 0);
      formdata.append("library_id", this.requiredLibraryId);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/libraries/update/${this.editLibraryId}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.status == "success") {
            this.$refs.modalfour.hide();
            console.log(response);
            (this.libraryName = ""),
              (this.libraryDescription = ""),
              (this.libraryImage = ""),
              (this.libraryDocument = "");
            (this.viewAccess = ""), (this.downloadAccess = "");
            this.$swal("Success", "Library updated successfully", "success");
            this.getLibraries(this.requiredLibraryId);
            (this.libraryImageEmpty = false),
              (this.libraryDocumentEmpty = false),
              (this.libraryCheckboxEmpty = false);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async loadLibrary(id) {
      this.editLibraryId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/libraries/edit/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.libraryName = response.data.libraries.name;
            this.libraryDescription = response.data.libraries.description;
            this.libraryImage = response.data.libraries.image;
            this.libraryDocument = response.data.libraries.document;
            this.viewAccess = response.data.libraries.view ? true : false;
            this.downloadAccess = response.data.libraries.download
              ? true
              : false;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async editParentTopics() {
      if (this.parentLibraryName == "") {
        this.parentTopicEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.parentLibraryName);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/libraries/update/${this.editParentTopicId}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$refs.modalthree.hide();
            this.getParentTopics();
            this.$swal(
              "Success",
              "Parent topic updated successfully",
              "success"
            );
            this.parentLibraryName = "";
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async loadParentTopic(id) {
      this.editParentTopicId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/libraries/edit/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.parentLibraryName = response.data.libraries.name;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },
    async deleteLibrary(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/libraries/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.getLibraries(this.requiredLibraryId);
            this.$swal("Success", "Library deleted successfully", "success");
          } else {
           this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async deleteParentTopic(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/libraries/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.getParentTopics();
            this.$swal(
              "Success",
              "Parent topic deleted successfully",
              "success"
            );
            if(response.data.message == "Library has child.") {
              this.$swal("Error", "Please delete the libraries before deleting the parent topic", "warning");
            }
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    cancelButtonLibrary() {
      (this.libraryName = ""),
        (this.libraryDescription = ""),
        (this.libraryImage = ""),
        (this.libraryDocument = "");
      (this.viewAccess = ""), (this.downloadAccess = "");
      this.$refs.modaltwo.hide();
      (this.libraryCheckboxEmpty = false),
        (this.libraryDocumentEmpty = false),
        (this.libraryImageEmpty = false),
        (this.libraryDescriptionEmpty = false),
        (this.libraryNameEmpty = false);
    },
    editCancelButtonParentLibrary() {
      this.parentLibraryName = "";
      this.$refs.modalthree.hide();
      this.parentTopicEmpty = false;
    },
    cancelButtonParentLibrary() {
      this.parentLibraryName = "";
      this.$refs.modalone.hide();
      this.parentTopicEmpty = false;
    },
    async getLibraries(id) {
      this.addlibraryButton = true;
      this.requiredLibraryId = id;
      const formdata = new FormData();
      formdata.append("id", id);
      await axios
        .post(`${this.$store.getters.baseUrl}/libraries`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.libraries = response.data.libraries;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getParentTopics() {
      this.loader = true
      await axios
        .get(`${this.$store.getters.baseUrl}/libraries/dropdown`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then(async(response) => {
          console.log(response);
          this.parentTopics = await response.data.topics;
          this.loader = false
        })
        .catch((error) => {
          console.log(error);
          this.loader = false
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async addParentLibrary() {
      if (this.parentLibraryName == "") {
        this.parentTopicEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.parentLibraryName);
      await axios
        .post(`${this.$store.getters.baseUrl}/libraries/add`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$refs.modalone.hide();
            console.log(response);
            this.$swal("Success", "Parent topic added successfully", "success");
            this.getParentTopics();
            this.parentLibraryName = "";
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    libraryimageUpload(event) {
      this.libraryImage = event.target.files[0];
    },

    libraryDocumentUpload(event) {
      this.libraryDocument = event.target.files[0];
    },
    async addLibrary() {
      if (this.libraryName == "") {
        this.libraryNameEmpty = true;
        return;
      }
      if (this.libraryDescription == "") {
        this.libraryDescriptionEmpty = true;
        return;
      }
      if (this.libraryImage == "") {
        this.libraryImageEmpty = true;
        return;
      }
      if (this.libraryDocument == "") {
        this.libraryDocumentEmpty = true;
        return;
      }
      if (this.viewAccess == "" && this.downloadAccess == "") {
        this.libraryCheckboxEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.libraryName);
      formdata.append("description", this.libraryDescription);
      formdata.append("image", this.libraryImage);
      formdata.append("document", this.libraryDocument);
      formdata.append("download", this.downloadAccess ? 1 : 0);
      formdata.append("view", this.viewAccess ? 1 : 0);
      formdata.append("library_id", this.requiredLibraryId);
      await axios
        .post(`${this.$store.getters.baseUrl}/libraries/add`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$refs.modaltwo.hide();
            console.log(response);
            (this.libraryName = ""),
              (this.libraryDescription = ""),
              (this.libraryImage = ""),
              (this.libraryDocument = "");
            (this.viewAccess = ""), (this.downloadAccess = "");
            this.$swal("Success", "Library added successfully", "success");
            this.getLibraries(this.requiredLibraryId);
            this.libraryImageEmpty = false;
            this.libraryDocumentEmpty = false;
            this.libraryCheckboxEmpty = false;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}

Button:focus {
  outline: none;
}

#addParentTopicButton {
  background-color: #e1e6e9;
}

#addLibraryButton {
  background-color: #e1e6e9;
}
</style>
